import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://ijjzaaazemgjntfauoti.supabase.co";
const supabaseKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlqanphYWF6ZW1nam50ZmF1b3RpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ3MDUwMzAsImV4cCI6MjA5MDI4MTAzMH0.sg8_cmJDufQpSs3uoO172y-sldbtvXGg9MbQkUQrtrs";

export const supabase = createClient(supabaseUrl, supabaseKey);
